import React from 'react';
import {
  Center,
  Text,
  VStack,
  HStack,
  Icon,
  IconButton,
} from '@wegroup/design-system';
import { SelectedQuote } from '../../../types/storeTypes';

interface Props {
  quote: SelectedQuote;
  onRemove: (id: string) => void;
}

const SelectedQuoteItem: React.FC<Props> = ({ quote, onRemove }) => {
  return (
    <Center
      position="relative"
      w="100%"
      borderRadius="lg"
      border="2px"
      borderColor="gray.50"
      borderStyle="dashed"
      p={{ base: '2', laptopL: '4' }}
    >
      <HStack justify="space-between" spacing="2" w="100%">
        <VStack align="flex-start">
          <Text textStyle="extraSmallBody" color="gray.500">
            {quote.company_name}
          </Text>
          <Text>{quote.name}</Text>
        </VStack>
        <Text textStyle="normalBodyBold">{quote.price}</Text>
      </HStack>
      <IconButton
        aria-label="remove"
        borderRadius="full"
        size="sm"
        position="absolute"
        top="0"
        right="0"
        transform="auto"
        translateX="30%"
        translateY="-30%"
        onClick={() => onRemove(quote.id)}
        variant="white"
        icon={<Icon name="GeneralActionsCloseOrRemove" />}
      />
    </Center>
  );
};

export default SelectedQuoteItem;
